import { render, staticRenderFns } from "./AgreementStatTiles.vue?vue&type=template&id=4ca89210&scoped=true&lang=pug&"
import script from "./AgreementStatTiles.vue?vue&type=script&lang=js&"
export * from "./AgreementStatTiles.vue?vue&type=script&lang=js&"
import style0 from "./AgreementStatTiles.vue?vue&type=style&index=0&id=4ca89210&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca89210",
  null
  
)

export default component.exports